import { searchFieldWrapperStyles } from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import { css } from "styled-components";

searchFieldWrapperStyles.wrapper = {
    css: css`
            padding: 10px;
            width: 100%;
            > div {
                div[class^="FormInputWrapper"] {
                    input {
                        height: 40px !important;
                    }
            }
            }
            ${() => isThemeActive(THEME_IDS.MGBW) ? `
                label[class^="TypographyStyle"] {
                    color: #323132 !important;
                }
            ` : ""}
        `,
    }
